<div style="width: 700px; max-width: 100%">
  <h2 class="mb-4">Adding clients</h2>
  <p>You can add clients to Client Hub in two ways: </p>
  <ol class="mt-4">
    <li>
      <h4>Import Clients</h4>
      <p>If you already have your client data in a spreadsheet form, then you can refer to <a target="_blank" rel="noreferrer noopener" href="https://clienthub.reamaze.com/articles/setting-up-a-client-account">this help
        article</a> to setup your data and then use the Import Clients and Import Contacts menus on the left to import this
        data to Client Hub</p>  
    </li>
    <li class="mt-4">
      <h4>Add Clients directly</h4>
      <p>If you don’t have client data in a spreadsheet form, then you can add each client
        directly in Client Hub by clicking on this button below.</p>
        <a target="_blank" rel="noreferrer noopener" class="btn btn-primary mt-4" (click)="openAddClientModal(null)">Add a New
          Client</a>
    </li>
  </ol>

  
  <hr>
  <p style="font-size: 14px">Once a client is added to Client Hub, you can add details about the client by going to the
    <strong><i class="tio-group_equal"></i> Clients and Workspaces</strong> menu,
    selecting that client and then going to the <strong><i class="tio-info"></i> Client Details</strong> tab.</p>
</div>